import { Routes } from "@angular/router";

import {AppComponent} from "./components/app/app.component";
import {MapComponent} from "./components/map/map.component";
import {SpotDetailsComponent} from "./components/spot-details/spot-details.component";

export const ROUTES: Routes = [
  { path: "", component: MapComponent },
  { path: "spot/:id", component: SpotDetailsComponent },
  { path: "map/:id", component: MapComponent },
];



// WEBPACK FOOTER //
// ./src/app/routes.ts